import script from "./NoUploadedProfilePhotoFoundComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NoUploadedProfilePhotoFoundComponent.vue?vue&type=script&setup=true&lang=js"

import "./NoUploadedProfilePhotoFoundComponent.vue?vue&type=style&index=0&id=31b2a350&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31b2a350"]])

export default __exports__